import React from 'react';

import { User } from '../../types/items';
import CreditHistoryTable from './CreditHistory/CreditHistoryTable';
import RemainingCreditsTip from './CreditHistory/RemainingCreditsTip';

type Props = {
  user: User;
};

const CreditHistoryPage = ({ user }: Props) => {

  return (
    <div>
      <RemainingCreditsTip user={user} />
      <CreditHistoryTable user={user} />
    </div>
  );
};

export default CreditHistoryPage;
